export default {
  isHomeModalVisible: state => {
    return state.modals.showHome;
  },
  isAboutModalVisible: state => {
    return state.modals.showAbout;
  },
  isScienceModalVisible: state => {
    return state.modals.showScience;
  }
};
